var _defs, _path, _rect, _polyline, _rect2, _rect3, _line, _line2, _rect4, _rect5, _rect6, _path2, _line3, _line4, _circle, _line5, _circle2, _path3, _path4, _path5, _circle3, _circle4, _rect7, _line6, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polyline2, _polyline3, _path16, _path17, _line7, _path18, _path19, _path20, _path21, _polyline4, _line8, _line9, _line10, _line11, _path22, _path23, _path24, _path25, _rect8, _path26, _line12, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _line13, _path38, _path39, _path40, _polyline5, _path41, _line14, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _rect9, _g, _text, _text2, _path42, _g2, _rect10, _rect11, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g3, _polygon, _g4, _polygon2, _g5, _polygon3, _g6, _polygon4, _g7, _polygon5, _g8, _polygon6, _polygon7, _g9, _polygon8, _g10, _polygon9, _g11, _polygon10, _g12, _polygon11, _g13, _polygon12, _polygon13, _g14, _polygon14, _g15, _polygon15, _g16, _polygon16, _g17, _polygon17, _g18, _polygon18, _polygon19, _g19, _polygon20, _g20, _polygon21, _g21, _polygon22, _g22, _polygon23, _g23, _polygon24, _polygon25, _g24, _polygon26, _g25, _polygon27, _g26, _polygon28, _g27, _polygon29, _g28, _polygon30, _tspan, _tspan2, _circle5, _path68, _path69, _rect12, _rect13, _rect14, _rect15, _circle6, _path70, _path71, _rect16, _rect17, _rect18, _rect19, _circle7, _path72, _path73, _rect20, _rect21, _rect22, _rect23, _path74, _polygon31, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNuevo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg23879",
    viewBox: "0 0 871.4 557.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs762"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_201",
    x1: -100.94,
    y1: 530.14,
    x2: -111.5,
    y2: 478.15,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, 264.71, 561.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "stop670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#343434",
    id: "stop672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7f7f7f",
    id: "stop674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d9d9d9",
    id: "stop676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    id: "stop678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_202",
    x1: -100.94,
    y1: 530.14,
    x2: -111.5,
    y2: 478.15,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, 264.71, 561.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbda25",
    id: "stop681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a1bf38",
    id: "stop683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6aa842",
    id: "stop685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4d8c42",
    id: "stop687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386639",
    id: "stop689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_203",
    x1: -90.41,
    y1: 503.96,
    x2: -95.16,
    y2: 480.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_204",
    x1: -90.41,
    y1: 503.96,
    x2: -95.16,
    y2: 480.59,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, 264.71, 561.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1bf38",
    id: "stop693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a1bf38",
    id: "stop695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6aa842",
    id: "stop697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4d8c42",
    id: "stop699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386639",
    id: "stop701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_205",
    x1: -92.74,
    y1: 501.49,
    x2: -101.91,
    y2: 456.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_206",
    x1: -92.74,
    y1: 501.49,
    x2: -101.91,
    y2: 456.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_207",
    x1: -105.79,
    y1: 509.22,
    x2: -117.74,
    y2: 450.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_208",
    x1: -105.79,
    y1: 509.22,
    x2: -117.74,
    y2: 450.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_209",
    x1: -117.51,
    y1: 496.92,
    x2: -121.1,
    y2: 479.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210",
    x1: -117.51,
    y1: 496.92,
    x2: -121.1,
    y2: 479.23,
    gradientTransform: "matrix(1, -0.1, -0.1, -1, 264.71, 561.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbda25",
    id: "stop709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a1bf38",
    id: "stop711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a1bf38",
    id: "stop713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6aa842",
    id: "stop715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4d8c42",
    id: "stop717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386639",
    id: "stop719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_211",
    x1: -46.48,
    y1: 530.15,
    x2: -57.04,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_212",
    x1: -46.48,
    y1: 530.15,
    x2: -57.04,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_213",
    x1: -35.96,
    y1: 503.97,
    x2: -40.71,
    y2: 480.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_214",
    x1: -35.96,
    y1: 503.97,
    x2: -40.71,
    y2: 480.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_215",
    x1: -38.28,
    y1: 501.5,
    x2: -47.45,
    y2: 456.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_216",
    x1: -38.28,
    y1: 501.5,
    x2: -47.45,
    y2: 456.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_217",
    x1: -51.28,
    y1: 509.21,
    x2: -63.23,
    y2: 450.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_218",
    x1: -51.28,
    y1: 509.21,
    x2: -63.23,
    y2: 450.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_219",
    x1: -63.05,
    y1: 496.93,
    x2: -66.64,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_220",
    x1: -63.05,
    y1: 496.93,
    x2: -66.64,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_221",
    x1: 7.97,
    y1: 530.15,
    x2: -2.59,
    y2: 478.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_222",
    x1: 7.97,
    y1: 530.15,
    x2: -2.59,
    y2: 478.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_223",
    x1: 18.55,
    y1: 503.96,
    x2: 13.81,
    y2: 480.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_224",
    x1: 18.55,
    y1: 503.96,
    x2: 13.81,
    y2: 480.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_225",
    x1: 16.17,
    y1: 501.5,
    x2: 7.01,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_226",
    x1: 16.17,
    y1: 501.5,
    x2: 7.01,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_227",
    x1: 3.23,
    y1: 509.21,
    x2: -8.72,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_228",
    x1: 3.23,
    y1: 509.21,
    x2: -8.72,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_229",
    x1: -8.59,
    y1: 496.93,
    x2: -12.18,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_230",
    x1: -8.59,
    y1: 496.93,
    x2: -12.18,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_231",
    x1: 61.98,
    y1: 530.15,
    x2: 51.42,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_232",
    x1: 61.98,
    y1: 530.15,
    x2: 51.42,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_233",
    x1: 72.56,
    y1: 503.96,
    x2: 67.81,
    y2: 480.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_234",
    x1: 72.56,
    y1: 503.96,
    x2: 67.81,
    y2: 480.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_235",
    x1: 70.18,
    y1: 501.5,
    x2: 61.01,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_236",
    x1: 70.18,
    y1: 501.5,
    x2: 61.01,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_237",
    x1: 57.24,
    y1: 509.21,
    x2: 45.29,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_238",
    x1: 57.24,
    y1: 509.21,
    x2: 45.29,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_239",
    x1: 45.41,
    y1: 496.93,
    x2: 41.82,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_240",
    x1: 45.41,
    y1: 496.93,
    x2: 41.82,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_241",
    x1: 115.99,
    y1: 530.15,
    x2: 105.43,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_242",
    x1: 115.99,
    y1: 530.15,
    x2: 105.43,
    y2: 478.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_243",
    x1: 126.51,
    y1: 503.97,
    x2: 121.77,
    y2: 480.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_244",
    x1: 126.51,
    y1: 503.97,
    x2: 121.77,
    y2: 480.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_245",
    x1: 124.18,
    y1: 501.5,
    x2: 115.02,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_246",
    x1: 124.18,
    y1: 501.5,
    x2: 115.02,
    y2: 456.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_247",
    x1: 111.25,
    y1: 509.2,
    x2: 99.3,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_248",
    x1: 111.25,
    y1: 509.2,
    x2: 99.3,
    y2: 450.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_249",
    x1: 99.42,
    y1: 496.93,
    x2: 95.83,
    y2: 479.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_250",
    x1: 99.42,
    y1: 496.93,
    x2: 95.83,
    y2: 479.24
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78,490.6l34.4,34.5a19.13,19.13,0,0,0,27.1,0L174,490.7a19.16,19.16,0,0,1,13.5-5.6l683.6,1.3-.4-253L.3,231.2,0,484.2l64.5.8A19.41,19.41,0,0,1,78,490.6Z",
    fill: "#f2f2f2",
    id: "path764"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 314.76,
    y: 361.49,
    width: 160.96,
    height: 11,
    rx: 4.66,
    transform: "translate(-36.76 44.08) rotate(-6.1)",
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect766"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "325.32 380 332.79 449.9 341.88 448.93 339.79 429.39",
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "polyline768"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 326.52,
    y: 377.19,
    width: 51.39,
    height: 25.32,
    transform: "translate(-39.43 39.64) rotate(-6.1)",
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect770"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 329.21,
    y: 402.37,
    width: 51.39,
    height: 25.32,
    transform: "translate(-42.09 40.06) rotate(-6.1)",
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect772"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 345.29,
    y1: 390.6,
    x2: 360.41,
    y2: 388.98,
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line774"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 347.98,
    y1: 415.78,
    x2: 363.11,
    y2: 414.16,
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line776"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 462.55,
    y: 365.09,
    width: 9.1,
    height: 84.03,
    transform: "translate(-40.62 51.94) rotate(-6.1)",
    fill: "#fff",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect778"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 243.68,
    y: 334.33,
    width: 79.5,
    height: 113.03,
    rx: 8.27,
    fill: "#fff",
    id: "rect780"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.79,
    y: 334.7,
    width: 79.27,
    height: 112.7,
    rx: 8.24,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.24,431.16v6.12a5.35,5.35,0,0,1-5.34,5.35h-5.16",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path784"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 319.24,
    y1: 423.52,
    x2: 319.24,
    y2: 427.34,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line786"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 244.75,
    y1: 360.49,
    x2: 323.07,
    y2: 360.49,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line788"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.74,
    cy: 346.16,
    r: 5.73,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "circle790"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 312.41,
    y1: 342.23,
    x2: 304.93,
    y2: 349.7,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line792"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.38,
    cy: 402.03,
    r: 29.13,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "circle794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309,398.19a25.68,25.68,0,0,1,.3,3.95,25.28,25.28,0,0,1-2,9.82",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path796"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M303.62,413.39a22.64,22.64,0,1,1-.17-22.8",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path798"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.45,390.78a24.55,24.55,0,0,0,0,22.18",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path800"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.37,
    cy: 346.16,
    r: 2.87,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "circle802"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.82,
    cy: 346.16,
    r: 2.87,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "circle804"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 251.43,
    y: 340.43,
    width: 23.88,
    height: 15.28,
    rx: 2.5,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect806"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 257.16,
    y1: 345.21,
    x2: 269.58,
    y2: 345.21,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.79,385.26a14.85,14.85,0,0,0,6.13,14.13",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path810"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.06,382.71a14.81,14.81,0,0,0-.92,15.33",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path812"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.55,391s-9.11-.82-13.81,7.44",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.77,398.43a14.27,14.27,0,0,0-10.43,2.41",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path816"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.51,416.87s-.15-9.49-9.34-13.16",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path818"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.6,421.44s4.28-8.72-2.57-16.21",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path820"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.85,415.05a14.87,14.87,0,0,0,12.41-9.87",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path822"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264.78,406.79a14.78,14.78,0,0,0,14.74-3.14",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path824"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.57,313.63H419.2A16.38,16.38,0,0,1,435.57,330v36.83a6.05,6.05,0,0,1-6.05,6.05H398.24a6.05,6.05,0,0,1-6.05-6.05V330a16.38,16.38,0,0,1,16.38-16.38Z",
    transform: "translate(75.91 -74.96) rotate(11.39)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path826"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M412.54,390.7c-2.44,0-4.42-1.15-4.42-2.58v-45.9c0-1.43,2-2.58,4.42-2.58s4.43,1.15,4.43,2.58v45.9C417,389.55,415,390.7,412.54,390.7Z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path828"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "412.14 432.77 434.61 442.98 434.66 447.7",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "polyline830"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "412.03 432.77 389.56 442.98 389.51 447.7",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "polyline832"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M412.14,433.28a2.58,2.58,0,0,1-2.58-2.59V393.42a2.59,2.59,0,1,1,5.17,0v37.27A2.59,2.59,0,0,1,412.14,433.28Z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path834"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M398.14,384h27.78a8.32,8.32,0,0,1,8.32,8.32V400a0,0,0,0,1,0,0H389.82a0,0,0,0,1,0,0v-7.72A8.32,8.32,0,0,1,398.14,384Z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path836"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 412.18,
    y1: 434.86,
    x2: 412.18,
    y2: 448.66,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line838"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.06,447.2h15.59a4,4,0,0,0,3.95-3.95V399.82a13.18,13.18,0,0,0-7-24.71,13.43,13.43,0,0,0-12.55,13.54V405.4",
    fill: "#fff",
    id: "path840"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.15,375.59v1.29a2.46,2.46,0,0,0,2.46,2.46h1.23a2.46,2.46,0,0,1,2.46,2.46v1.35a2.46,2.46,0,0,0,2.46,2.46h5.45a2.46,2.46,0,0,0,2.46-2.46v-5.34",
    fill: "#fff",
    id: "path842"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M233.67,447.69V363a19.52,19.52,0,0,0-19.52-19.52h-27c-.85,0-3.19.21-4,.32l-.41-8.53V285.19a5.93,5.93,0,0,0-5.93-5.93H87.35a5.93,5.93,0,0,0-5.93,5.93V431.34a5.92,5.92,0,0,0,5.93,5.93h-.19v8a2,2,0,0,0,2,2h15.72a2,2,0,0,0,2-2v-8H145l7.53-.06v6a4,4,0,0,0,3.95,3.95H172",
    fill: "#fff",
    id: "path844"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,437.94H87.57A5.93,5.93,0,0,1,81.64,432V285.86a5.93,5.93,0,0,1,5.93-5.93H177a5.92,5.92,0,0,1,5.92,5.93v50.06",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path846"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "81.64 292.77 92.45 292.77 96.26 300.28 100.56 292.77 182.91 292.77",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "polyline848"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 81.64,
    y1: 425.1,
    x2: 152.73,
    y2: 425.1,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line850"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 132.28,
    y1: 292.77,
    x2: 132.28,
    y2: 425.1,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line852"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 120.42,
    y1: 348.97,
    x2: 120.42,
    y2: 371.92,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line854"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 144.13,
    y1: 348.97,
    x2: 144.13,
    y2: 371.92,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line856"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.38,437.94h19.67a0,0,0,0,1,0,0v8a2,2,0,0,1-2,2H89.36a2,2,0,0,1-2-2v-8A0,0,0,0,1,87.38,437.94Z",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.7,362.53h-3.34a2.46,2.46,0,0,1-2.46-2.46v-2.38a2.47,2.47,0,0,0-2.46-2.47h-3.69a2.47,2.47,0,0,0-2.46,2.47v9.13a2.46,2.46,0,0,1-2.46,2.46h0a2.46,2.46,0,0,0-2.46,2.46v5.81a2.46,2.46,0,0,0,2.46,2.46h1.23a2.46,2.46,0,0,1,2.46,2.46v1.34a2.46,2.46,0,0,0,2.46,2.46h5.45a2.46,2.46,0,0,0,2.46-2.46v-5.33a2.46,2.46,0,0,1,2.46-2.46h.35a2.46,2.46,0,0,0,2.46-2.46V365A2.46,2.46,0,0,0,217.7,362.53Z",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path860"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.26,406.06V389.32a13.44,13.44,0,0,0-12.54-13.55,13.18,13.18,0,0,0-7,24.72v43.43a4,4,0,0,0,4,3.95h15.58V422.23",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path862"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M224.29,406.06V389.32a13.44,13.44,0,0,1,12.54-13.55,13.19,13.19,0,0,1,7,24.72v43.43a4,4,0,0,1-4,3.95H224.29V422.23",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path864"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 165.69,
    y: 406.06,
    width: 65.18,
    height: 16.16,
    rx: 4.7,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "rect866"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.69,376.26V363.65a19.52,19.52,0,0,1,19.52-19.52h32.16a19.52,19.52,0,0,1,19.52,19.52v12.61",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "path868"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 172.26,
    y1: 447.87,
    x2: 224.29,
    y2: 447.87,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.01,
    id: "line870"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M509.1,413.24l3.48,22.58m-13.86,14.6h10.09l6.63.05,50.47-.18a5.72,5.72,0,0,0,5.72-5.72V389.31l-3.12,61.27c.61,0,10-.29,10.61-.29,17.85,0,32.32-4.49,32.32-22.34,0-15.94-13.14-35-24-40.74l12.56-11a2.35,2.35,0,0,0,.09-3.45l-4.81-4.64.46-.64a2.35,2.35,0,0,0-1.32-3.63l-11.94-3.13a2.35,2.35,0,0,0-2.94,2.29l.24,22.72h0a23.24,23.24,0,0,0-8.17,3.58V346.72a5.72,5.72,0,0,0-5.72-5.73H498l-.36,63.22m82.19-18.48,8.11,1.42,7.39-19-7.84,19.09C586.16,386.53,581.19,385.49,579.8,385.73Z",
    fill: "#fff",
    id: "path872"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M505.12,403.14l-8.62-12.76h0l-.12-48.94,69.53-.45a9.19,9.19,0,0,0-9.19-9.19c-.23,0-.46,0-.68,0a11.24,11.24,0,0,0,.16-1.84,11,11,0,0,0-20.62-5.3,6.84,6.84,0,0,0-12.69-.79A9.92,9.92,0,0,0,505.23,333c-.3,0-.6-.05-.9-.05a8.07,8.07,0,0,0-7.83,6.1V317.41H488v73l-8.62,12.76a2.34,2.34,0,0,0,.25,2.93l2.54,2.66a2.33,2.33,0,0,0,1.7.73h16.78a2.33,2.33,0,0,0,1.7-.73l2.54-2.66A2.35,2.35,0,0,0,505.12,403.14Z",
    fill: "#fff",
    id: "path874"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M572.08,390.2a23,23,0,0,1,8.17-3.57c1.38-.25,6.35.79,7.65,1.48,10.85,5.73,24,24.79,24,40.73,0,17.85-14.47,22.35-32.33,22.35l-1.78,0",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path876"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M601.83,418a27.89,27.89,0,0,1,1.81,9.39c0,9.48-5.73,13.87-14,15.59",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path878"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M580.25,386.63,580,363.91a2.35,2.35,0,0,1,2.94-2.3l11.94,3.13a2.34,2.34,0,0,1,1.31,3.63l-6,8.38",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path880"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M595.75,369l4.8,4.64a2.34,2.34,0,0,1-.08,3.45l-12.57,11",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path882"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M515.26,451.19h51.09a5.73,5.73,0,0,0,5.73-5.73V347.61a5.72,5.72,0,0,0-5.73-5.73H498.41",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path884"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M496.94,339.92a8.07,8.07,0,0,1,7.83-6.11,9.08,9.08,0,0,1,.91.05,9.79,9.79,0,0,1-1.05-4.42,9.93,9.93,0,0,1,18.71-4.63,6.84,6.84,0,0,1,12.69.78,11,11,0,0,1,20.62,5.3,10.16,10.16,0,0,1-.17,1.84c.23,0,.46,0,.69,0a9.19,9.19,0,0,1,9.18,9.19",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path886"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M530.19,332.1a8.18,8.18,0,0,0-11.27,2.66",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path888"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M552.79,335a6.64,6.64,0,0,0-9.38-.45",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path890"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M518.4,390.23c0,16.38,12.89,25.65,15.22,25.65s15.21-9.27,15.21-25.65-12.19-33.67-15.22-33.66S518.4,373.85,518.4,390.23Z",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path892"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 533.62,
    y1: 415.88,
    x2: 533.61,
    y2: 356.57,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "line894"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M539.72,371.58a20,20,0,0,1-6.11,6.05",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path896"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M544.27,393.18a27.39,27.39,0,0,1-10.65,8.07",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path898"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M524.32,379.84a39.79,39.79,0,0,0,9.3,11.34",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path900"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "496.94 318.31 496.94 391.28 488.43 391.28 488.43 318.31",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline902"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M505.56,404l-8.62-12.75h-8.51L479.81,404a2.35,2.35,0,0,0,.24,2.94l2.55,2.66a2.34,2.34,0,0,0,1.69.72h16.79a2.34,2.34,0,0,0,1.69-.72l2.55-2.66A2.35,2.35,0,0,0,505.56,404Z",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "path904"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 492.69,
    y1: 410.35,
    x2: 492.69,
    y2: 451.19,
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "line906"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "488.31 410.35 481.28 445.35 482.31 449.37",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline908"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "483.63 410.35 470.29 441.5 471.51 445.77",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline910"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "480.05 406.97 460.81 432.78 461.98 437.55",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline912"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "497.06 410.35 504.09 445.35 503.06 449.37",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline914"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "501.75 410.35 515.08 441.5 513.86 445.77",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline916"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "505.32 406.97 524.56 432.78 523.39 437.55",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.34,
    id: "polyline918"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 223.75,
    width: 871.46,
    height: 251.58,
    fill: "#f2f2f2",
    opacity: 0.58,
    id: "rect920"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    id: "g926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5,484.2A19,19,0,0,0,58,478.6l-57-.7v6.4l64.5.8a19.14,19.14,0,0,1,9.4,2.5Z",
    fill: "#404040",
    id: "path922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.7,233.5h-7.5l.4,246.6L181,478.8a19,19,0,0,0-13.5,5.6L133,518.7a19.15,19.15,0,0,1-22.9,3.1l3.4,3.4a19.13,19.13,0,0,0,27.1,0l34.5-34.4a19.16,19.16,0,0,1,13.5-5.6l683.6,1.3Z",
    fill: "#404040",
    id: "path924"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontSize: "90.15px",
    fill: "#ffffff",
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800,
    id: "text938",
    x: 44.426426,
    y: 460.37393
  }, "Bienvenido!")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontSize: "90.15px",
    fill: "#80c0dd",
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800,
    id: "text944",
    x: 47.438751,
    y: 455.70572
  }, "Bienvenido!")), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M870.8,0H0V248.5l64.6.8a18.82,18.82,0,0,1,13.5,5.6l34.5,34.5a19.13,19.13,0,0,0,27.1,0L174.3,255a19.22,19.22,0,0,1,13.6-5.6l683,.3",
    fill: "#f4d500",
    id: "path946"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    id: "g952"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9,248.4a19.16,19.16,0,0,0-13.5-5.6l-57.1-.7v6.4l64.6.8a19.81,19.81,0,0,1,9.5,2.5Z",
    fill: "#404040",
    id: "path948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872,0h-7.5l.2,243.3-683-.3a19.22,19.22,0,0,0-13.6,5.6L133.5,283a19.28,19.28,0,0,1-23,3.1l3.4,3.4a19.13,19.13,0,0,0,27.1,0l34.6-34.4a19.22,19.22,0,0,1,13.6-5.6l683,.3Z",
    fill: "#404040",
    id: "path950"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72.55,
    y: 148.44,
    width: 193.01,
    height: 37.87,
    transform: "translate(-10.06 10.81) rotate(-3.56)",
    fill: "#80bfdc",
    id: "rect954"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.77,
    y: 183.2,
    width: 272.53,
    height: 37.87,
    transform: "translate(-12.14 13.48) rotate(-3.56)",
    fill: "#80bfdc",
    id: "rect956"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M105,213.07h0a7.44,7.44,0,0,1-1.55,5.77,7.58,7.58,0,0,1-5.55,2.33,7.87,7.87,0,0,1-6-2,9.1,9.1,0,0,1-2.55-6.55L88.87,206a9.33,9.33,0,0,1,1.78-6.78,7.75,7.75,0,0,1,5.66-2.77c2.45-.11,4.44.33,5.89,1.55a7.14,7.14,0,0,1,2.33,5.44v.11l-3.22.23a5.37,5.37,0,0,0-1.33-3.67,4.3,4.3,0,0,0-3.45-1A4,4,0,0,0,93.2,201c-.77,1.11-1,2.78-.89,4.89l.45,6.66a8.15,8.15,0,0,0,1.55,4.78,3.92,3.92,0,0,0,3.56,1.44,4.24,4.24,0,0,0,3.22-1.44,5.68,5.68,0,0,0,.89-3.89Z",
    fill: "#fff",
    id: "path958"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75,219.84l-3.33.22-1.45-24,3.33-.22Z",
    fill: "#fff",
    id: "path960"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M133.74,218.51l-3.34.22L120,201.63h-.12L121,219.28l-3.34.23-1.44-24,3.33-.22L130,212.4h.11L129,194.74l3.33-.22Z",
    fill: "#fff",
    id: "path962"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M153,210.07h0a6.83,6.83,0,0,1-7.11,8.1,7.9,7.9,0,0,1-6-2,9.1,9.1,0,0,1-2.55-6.55l-.44-6.66a9.25,9.25,0,0,1,1.77-6.77,7.75,7.75,0,0,1,5.67-2.78c2.44-.11,4.44.33,5.88,1.55a7.13,7.13,0,0,1,2.33,5.45v.11l-3.22.22a5.32,5.32,0,0,0-1.33-3.67,4.32,4.32,0,0,0-3.44-1,4,4,0,0,0-3.33,1.89c-.78,1.11-1,2.78-.89,4.89l.44,6.66a8.12,8.12,0,0,0,1.56,4.78,3.91,3.91,0,0,0,3.55,1.44,4.21,4.21,0,0,0,3.22-1.44,5.63,5.63,0,0,0,.89-3.89Z",
    fill: "#fff",
    id: "path964"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M172.72,207.4a8.88,8.88,0,0,1-1.89,6.78,8.13,8.13,0,0,1-6,2.77,8.27,8.27,0,0,1-6.22-2c-1.55-1.44-2.44-3.66-2.66-6.55l-.45-6.55a8.85,8.85,0,0,1,1.89-6.77,7.83,7.83,0,0,1,5.89-2.78,8.7,8.7,0,0,1,6.33,2,9.43,9.43,0,0,1,2.77,6.55ZM168.94,201a6.88,6.88,0,0,0-1.67-4.66,4.8,4.8,0,0,0-3.88-1.34,4.3,4.3,0,0,0-3.56,1.89,7.91,7.91,0,0,0-1,4.89l.45,6.66a8.12,8.12,0,0,0,1.55,4.78,4.51,4.51,0,0,0,3.78,1.44,5,5,0,0,0,3.77-1.89,7.08,7.08,0,0,0,1-4.88Z",
    fill: "#fff",
    id: "path966"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M195.37,203.51l-8.11.56.56,8.66,9.66-.55.11,2.55-13,.78-1.45-24,12.89-.78.11,2.56-9.55.55.44,7.78,8.11-.56Z",
    fill: "#fff",
    id: "path968"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M211.47,207.62a4.13,4.13,0,0,0-1.11-2.66,8.92,8.92,0,0,0-3.44-1.78,11.86,11.86,0,0,1-5.33-2.44,5.47,5.47,0,0,1-2.11-4.33,6.21,6.21,0,0,1,1.66-4.78,7,7,0,0,1,5-2.11,7.46,7.46,0,0,1,5.44,1.67,6.55,6.55,0,0,1,2.22,5v.11l-3.22.22a5.06,5.06,0,0,0-1.33-3.33,3.64,3.64,0,0,0-3-1.11,3.43,3.43,0,0,0-2.66,1.33,4.21,4.21,0,0,0-.78,2.89,3.71,3.71,0,0,0,1.22,2.55,8.74,8.74,0,0,0,3.67,1.67,13.43,13.43,0,0,1,5.22,2.44,6.11,6.11,0,0,1,2,4.33,5.62,5.62,0,0,1-1.77,4.78,8.37,8.37,0,0,1-5.22,2.11,8.5,8.5,0,0,1-5.67-1.56,5.92,5.92,0,0,1-2.55-5.22v-.11l3.22-.22a4.48,4.48,0,0,0,1.56,3.55,4.27,4.27,0,0,0,3.33,1,4,4,0,0,0,2.88-1.22A3.61,3.61,0,0,0,211.47,207.62Z",
    fill: "#fff",
    id: "path970"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M232,190.86l-6.33.44L227,212.73l-3.33.22-1.34-21.43L216,192l-.11-2.56,16.11-1Z",
    fill: "#fff",
    id: "path972"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M238.9,201.63l.67,10.32-3.33.23-1.45-24,7.11-.44a7.53,7.53,0,0,1,5.44,1.44,6.64,6.64,0,0,1,2.22,5,5.69,5.69,0,0,1-.66,3.33,5.53,5.53,0,0,1-2.45,2.33,4.66,4.66,0,0,1,2.78,1.89,6.77,6.77,0,0,1,1,3.55l.11,2.11a5.4,5.4,0,0,0,.33,2,2.66,2.66,0,0,0,.89,1.44v.34l-3.44.22a2.92,2.92,0,0,1-.89-1.67l-.33-2.33-.11-2a5.34,5.34,0,0,0-1.11-3.11,3,3,0,0,0-2.67-1Zm-.11-2.56,3.55-.22a4,4,0,0,0,3-1.33,4.14,4.14,0,0,0,.78-3.22,4.92,4.92,0,0,0-1.11-3.11,4.07,4.07,0,0,0-3-1l-3.78.22Z",
    fill: "#fff",
    id: "path974"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M265.78,199.18l-8.11.56.55,8.66,9.67-.55.11,2.55-13,.78-1.44-24,12.88-.78.11,2.56-9.55.55.45,7.78,8.1-.56Z",
    fill: "#fff",
    id: "path976"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M274.55,207.29l9.77-.55.11,2.55-13.1.78-1.45-24,3.34-.22Z",
    fill: "#fff",
    id: "path978"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M290.87,206.18l9.78-.56.11,2.56-13.11.78-1.44-24,3.33-.22Z",
    fill: "#fff",
    id: "path980"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M314.53,201.18l-7.22.45L306,207.85l-3.45.22,5.78-24.43,3.22-.23L320.19,207l-3.44.22ZM307.86,199l5.67-.33-3.33-9.55h-.12Z",
    fill: "#fff",
    id: "path982"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M333.41,200.07a4.19,4.19,0,0,0-1.12-2.66,8.77,8.77,0,0,0-3.44-1.78,11.86,11.86,0,0,1-5.33-2.44,5.49,5.49,0,0,1-2.11-4.33,6.2,6.2,0,0,1,1.67-4.78,6.93,6.93,0,0,1,5-2.11,7.49,7.49,0,0,1,5.45,1.67,6.57,6.57,0,0,1,2.22,5v.12l-3.22.22a5,5,0,0,0-1.34-3.33,3.58,3.58,0,0,0-3-1.11,3.45,3.45,0,0,0-2.67,1.33,4.25,4.25,0,0,0-.78,2.89A3.74,3.74,0,0,0,326,191.3a8.62,8.62,0,0,0,3.66,1.67,13.36,13.36,0,0,1,5.22,2.44,6.12,6.12,0,0,1,2,4.33,5.63,5.63,0,0,1-1.78,4.77,8.26,8.26,0,0,1-5.22,2.11,8.4,8.4,0,0,1-5.66-1.55,5.9,5.9,0,0,1-2.56-5.22v-.11l3.22-.22a4.51,4.51,0,0,0,1.56,3.55,4.3,4.3,0,0,0,3.33,1,4.09,4.09,0,0,0,2.89-1.22A3.66,3.66,0,0,0,333.41,200.07Z",
    fill: "#fff",
    id: "path984"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.76,178.64h0l4.66-20,4.33-.22,1.44,24-3.33.22-1.11-17.33h-.11L99.2,183l-2.33.11L90.2,165.87h-.11l1.11,17.54-3.33.23-1.44-24,4.33-.22Z",
    fill: "#fff",
    id: "path986"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M127,157.1,128,173c.11,2.66-.44,4.77-1.89,6.33a8,8,0,0,1-5.66,2.55,7.73,7.73,0,0,1-5.89-1.89,8.41,8.41,0,0,1-2.55-6.11L111,158l3.33-.22,1,15.88a7,7,0,0,0,1.56,4.33,3.9,3.9,0,0,0,3.44,1.34,4.23,4.23,0,0,0,3.33-1.78,6.8,6.8,0,0,0,1-4.44l-1-15.88Z",
    fill: "#fff",
    id: "path988"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M148.84,179.86l-3.33.22L135.07,163H135l1.11,17.66-3.33.22-1.45-24,3.33-.22,10.44,17.1h.11l-1.11-17.65,3.34-.23Z",
    fill: "#fff",
    id: "path990"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M157.06,179.42l-3.33.22-1.45-24,3.33-.22Z",
    fill: "#fff",
    id: "path992"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M176.6,171h0a7.48,7.48,0,0,1-1.55,5.77,7.56,7.56,0,0,1-5.56,2.33,7.86,7.86,0,0,1-6-2,9.07,9.07,0,0,1-2.56-6.55l-.44-6.66a9.25,9.25,0,0,1,1.78-6.77,7.72,7.72,0,0,1,5.66-2.78,8.28,8.28,0,0,1,5.89,1.55,7.16,7.16,0,0,1,2.33,5.45v.11l-3.22.22A5.32,5.32,0,0,0,171.6,158a4.3,4.3,0,0,0-3.44-1,4.05,4.05,0,0,0-3.33,1.89c-.78,1.11-1,2.78-.89,4.89l.45,6.66a8.12,8.12,0,0,0,1.55,4.78,3.91,3.91,0,0,0,3.55,1.44,4.21,4.21,0,0,0,3.23-1.44,5.68,5.68,0,0,0,.88-3.89Z",
    fill: "#fff",
    id: "path994"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M184.38,177.75,181,178l-1.44-24,3.33-.23Z",
    fill: "#fff",
    id: "path996"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M192,167.76l.55,9.44-3.33.22-1.44-24,7.77-.44a7.15,7.15,0,0,1,5.44,1.66,7.24,7.24,0,0,1,2.22,5.11,7.41,7.41,0,0,1-1.66,5.44,7,7,0,0,1-5.22,2.33Zm-.22-2.67,4.44-.22a3.48,3.48,0,0,0,2.89-1.56,5,5,0,0,0,.77-3.44,5.51,5.51,0,0,0-1.22-3.33,3.58,3.58,0,0,0-3-1.22l-4.44.22Z",
    fill: "#fff",
    id: "path998"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58,176l-3.33.23-1.44-24,3.33-.22Z",
    fill: "#fff",
    id: "path1000"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M232.13,166a8.85,8.85,0,0,1-1.89,6.77,8.48,8.48,0,0,1-6,2.78,8.31,8.31,0,0,1-6.22-2c-1.55-1.44-2.44-3.66-2.66-6.55l-.45-6.55a8.88,8.88,0,0,1,1.89-6.78,7.87,7.87,0,0,1,5.89-2.77,8.7,8.7,0,0,1,6.33,2,9.43,9.43,0,0,1,2.77,6.55Zm-3.78-6.44a6.91,6.91,0,0,0-1.66-4.67,4.85,4.85,0,0,0-3.89-1.33,4.24,4.24,0,0,0-3.55,1.89,7.77,7.77,0,0,0-1,4.89l.44,6.66a8.16,8.16,0,0,0,1.55,4.77A4.53,4.53,0,0,0,224,173.2a5,5,0,0,0,3.78-1.89,7.22,7.22,0,0,0,1-4.89Z",
    fill: "#fff",
    id: "path1002"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M247.12,167.76a4.24,4.24,0,0,0-1.11-2.67,9.06,9.06,0,0,0-3.44-1.78,11.81,11.81,0,0,1-5.33-2.44,5.44,5.44,0,0,1-2.11-4.33,6.14,6.14,0,0,1,1.66-4.77,6.9,6.9,0,0,1,5-2.11,7.41,7.41,0,0,1,5.44,1.66,6.58,6.58,0,0,1,2.22,5v.11l-3.22.22a5.08,5.08,0,0,0-1.33-3.33,3.64,3.64,0,0,0-3-1.11,3.47,3.47,0,0,0-2.67,1.33,4.26,4.26,0,0,0-.77,2.89,3.69,3.69,0,0,0,1.22,2.55,8.62,8.62,0,0,0,3.66,1.67,13.36,13.36,0,0,1,5.22,2.44,6.14,6.14,0,0,1,2,4.33,5.62,5.62,0,0,1-1.78,4.78,8.29,8.29,0,0,1-5.21,2.11,8.45,8.45,0,0,1-5.67-1.56,5.91,5.91,0,0,1-2.55-5.22v-.11l3.22-.22a4.44,4.44,0,0,0,1.55,3.55,4.26,4.26,0,0,0,3.33,1,4.05,4.05,0,0,0,2.89-1.22A3.73,3.73,0,0,0,247.12,167.76Z",
    fill: "#fff",
    id: "path1004"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.51,20.39,84.1,46.27c-4.11.44-7,4.33-6.56,8.77l8,80.85c.44,4.44,4.11,7.66,8.22,7.21L112,141.33a2.38,2.38,0,0,1,2.55,2.33l2.56,25.87a.73.73,0,0,0,.44.56.53.53,0,0,0,.67-.11l35.31-31c2.34-1.77,2.34-1.77,4.89-2.22l197.67-19.54c4.11-.45,7-4.33,6.55-8.77l-8-80.85C354.28,23.28,350.62,20,346.51,20.39Z",
    fill: "#0c0c0c",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    },
    id: "path1006"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M346.18,17.17l-262.42,26c-4.11.44-7,4.33-6.55,8.77l8,80.85c.44,4.44,4.11,7.66,8.21,7.21l18.22-1.77a2.39,2.39,0,0,1,2.55,2.33l2.56,25.87a.73.73,0,0,0,.44.56.53.53,0,0,0,.67-.11l35.31-31c2.33-1.78,2.33-1.78,4.89-2.23l197.67-19.54c4.11-.45,7-4.33,6.55-8.77l-8-80.85A7.69,7.69,0,0,0,346.18,17.17Z",
    fill: "#f4d500",
    id: "path1008"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.76,43.16,346.18,17.28c4.11-.44,7.77,2.89,8.21,7.33l.67,7a7.86,7.86,0,0,0-8.22-7.33L84.43,50c-4.11.45-7,4.33-6.55,8.78l-.67-7C76.77,47.38,79.65,43.49,83.76,43.16Z",
    fill: "#fff",
    opacity: 0.28,
    style: {
      isolation: "isolate"
    },
    id: "path1010"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23,
    id: "g1022"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "117.3 82.03 109.42 64.03 105.2 83.25 85.65 85.14 102.53 95.13 98.42 114.23 113.08 101.24 129.96 111.12 122.08 93.13 136.85 80.14 117.3 82.03",
    fill: "#222221",
    id: "polygon1012"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.49 76.69 163.61 58.7 159.39 77.92 139.84 79.8 156.84 89.69 152.62 108.9 167.27 95.91 184.26 105.79 176.38 87.8 191.04 74.7 171.49 76.69",
    fill: "#222221",
    id: "polygon1014"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.69 71.36 217.8 53.37 213.58 72.47 194.04 74.47 211.03 84.36 206.81 103.57 221.47 90.47 238.46 100.46 230.57 82.47 245.23 69.37 225.69 71.36",
    fill: "#222221",
    id: "polygon1016"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.44 66.03 271.55 48.04 267.33 67.26 247.78 69.14 264.78 79.03 260.56 98.24 275.21 85.25 292.21 95.13 284.32 77.14 298.98 64.03 279.44 66.03",
    fill: "#222221",
    id: "polygon1018"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.73 58.82 333.18 60.7 325.3 42.71 321.08 61.92 301.53 63.81 318.52 73.81 314.31 92.91 328.96 79.92 345.95 89.8 338.07 71.81 352.73 58.82",
    fill: "#222221",
    id: "polygon1020"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "108.86 62.7 116.75 80.69 136.29 78.81 121.63 91.8 129.52 109.79 112.53 99.91 97.87 112.9 102.09 93.69 85.21 83.8 104.75 81.91 108.86 62.7",
    fill: "#4d8c42",
    id: "polygon1024"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.75 81.91 108.86 62.7 111.3 87.02 104.75 81.91",
    fill: "url(#Degradado_sin_nombre_201)",
    id: "polygon1026"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "104.75 81.91 108.86 62.7 111.3 87.02 104.75 81.91",
    fill: "url(#Degradado_sin_nombre_202)",
    id: "polygon1029"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-2",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 78.81 116.75 80.69 111.3 87.02 136.29 78.81",
    fill: "url(#Degradado_sin_nombre_203)",
    id: "polygon1031"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 78.81 116.75 80.69 111.3 87.02 136.29 78.81",
    fill: "url(#Degradado_sin_nombre_204)",
    id: "polygon1034"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-3",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "121.63 91.8 129.52 109.79 111.3 87.02 121.63 91.8",
    fill: "url(#Degradado_sin_nombre_205)",
    id: "polygon1036"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.63 91.8 129.52 109.79 111.3 87.02 121.63 91.8",
    fill: "url(#Degradado_sin_nombre_206)",
    id: "polygon1039"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-4",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.87 112.9 112.53 99.91 111.3 87.02 97.87 112.9",
    fill: "url(#Degradado_sin_nombre_207)",
    id: "polygon1041"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.87 112.9 112.53 99.91 111.3 87.02 97.87 112.9",
    fill: "url(#Degradado_sin_nombre_208)",
    id: "polygon1044"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-5",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "102.09 93.69 111.3 87.02 85.21 83.8 102.09 93.69",
    fill: "url(#Degradado_sin_nombre_209)",
    id: "polygon1046"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.09 93.69 111.3 87.02 85.21 83.8 102.09 93.69",
    fill: "url(#Degradado_sin_nombre_210)",
    id: "polygon1049"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.16 57.37 170.94 75.36 190.48 73.36 175.82 86.47 183.71 104.46 166.83 94.46 152.06 107.57 156.28 88.36 139.4 78.47 158.94 76.58 163.16 57.37",
    fill: "#4d8c42",
    id: "polygon1051"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-6",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.94 76.58 163.16 57.37 165.5 81.69 158.94 76.58",
    fill: "url(#Degradado_sin_nombre_211)",
    id: "polygon1053"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.94 76.58 163.16 57.37 165.5 81.69 158.94 76.58",
    fill: "url(#Degradado_sin_nombre_212)",
    id: "polygon1056"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-7",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "190.48 73.36 170.94 75.36 165.5 81.69 190.48 73.36",
    fill: "url(#Degradado_sin_nombre_213)",
    id: "polygon1058"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.48 73.36 170.94 75.36 165.5 81.69 190.48 73.36",
    fill: "url(#Degradado_sin_nombre_214)",
    id: "polygon1061"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-8",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.82 86.47 183.71 104.46 165.5 81.69 175.82 86.47",
    fill: "url(#Degradado_sin_nombre_215)",
    id: "polygon1063"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.82 86.47 183.71 104.46 165.5 81.69 175.82 86.47",
    fill: "url(#Degradado_sin_nombre_216)",
    id: "polygon1066"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-9",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.06 107.57 166.83 94.46 165.5 81.69 152.06 107.57",
    fill: "url(#Degradado_sin_nombre_217)",
    id: "polygon1068"
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.06 107.57 166.83 94.46 165.5 81.69 152.06 107.57",
    fill: "url(#Degradado_sin_nombre_218)",
    id: "polygon1071"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-10",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "156.28 88.36 165.5 81.69 139.4 78.47 156.28 88.36",
    fill: "url(#Degradado_sin_nombre_219)",
    id: "polygon1073"
  }))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.28 88.36 165.5 81.69 139.4 78.47 156.28 88.36",
    fill: "url(#Degradado_sin_nombre_220)",
    id: "polygon1076"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.36 52.04 225.24 70.03 244.79 68.03 230.13 81.14 237.9 99.13 221.02 89.13 206.36 102.24 210.58 83.03 193.59 73.14 213.14 71.14 217.36 52.04",
    fill: "#4d8c42",
    id: "polygon1078"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-11",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "213.14 71.14 217.36 52.04 219.69 76.36 213.14 71.14",
    fill: "url(#Degradado_sin_nombre_221)",
    id: "polygon1080"
  }))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.14 71.14 217.36 52.04 219.69 76.36 213.14 71.14",
    fill: "url(#Degradado_sin_nombre_222)",
    id: "polygon1083"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-12",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "244.79 68.03 225.24 70.03 219.69 76.36 244.79 68.03",
    fill: "url(#Degradado_sin_nombre_223)",
    id: "polygon1085"
  }))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.79 68.03 225.24 70.03 219.69 76.36 244.79 68.03",
    fill: "url(#Degradado_sin_nombre_224)",
    id: "polygon1088"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-13",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.13 81.14 237.9 99.13 219.69 76.36 230.13 81.14",
    fill: "url(#Degradado_sin_nombre_225)",
    id: "polygon1090"
  }))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.13 81.14 237.9 99.13 219.69 76.36 230.13 81.14",
    fill: "url(#Degradado_sin_nombre_226)",
    id: "polygon1093"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-14",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.36 102.24 221.02 89.13 219.69 76.36 206.36 102.24",
    fill: "url(#Degradado_sin_nombre_227)",
    id: "polygon1095"
  }))), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.36 102.24 221.02 89.13 219.69 76.36 206.36 102.24",
    fill: "url(#Degradado_sin_nombre_228)",
    id: "polygon1098"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-15",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.58 83.03 219.69 76.36 193.59 73.14 210.58 83.03",
    fill: "url(#Degradado_sin_nombre_229)",
    id: "polygon1100"
  }))), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "210.58 83.03 219.69 76.36 193.59 73.14 210.58 83.03",
    fill: "url(#Degradado_sin_nombre_230)",
    id: "polygon1103"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.11 46.71 278.99 64.7 298.54 62.7 283.77 75.81 291.65 93.8 274.77 83.8 260.11 96.91 264.22 77.69 247.34 67.81 266.89 65.92 271.11 46.71",
    fill: "#4d8c42",
    id: "polygon1105"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-16",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "266.89 65.92 271.11 46.71 273.44 71.03 266.89 65.92",
    fill: "url(#Degradado_sin_nombre_231)",
    id: "polygon1107"
  }))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.89 65.92 271.11 46.71 273.44 71.03 266.89 65.92",
    fill: "url(#Degradado_sin_nombre_232)",
    id: "polygon1110"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-17",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "298.54 62.7 278.99 64.7 273.44 71.03 298.54 62.7",
    fill: "url(#Degradado_sin_nombre_233)",
    id: "polygon1112"
  }))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "298.54 62.7 278.99 64.7 273.44 71.03 298.54 62.7",
    fill: "url(#Degradado_sin_nombre_234)",
    id: "polygon1115"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-18",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "283.77 75.81 291.65 93.8 273.44 71.03 283.77 75.81",
    fill: "url(#Degradado_sin_nombre_235)",
    id: "polygon1117"
  }))), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.77 75.81 291.65 93.8 273.44 71.03 283.77 75.81",
    fill: "url(#Degradado_sin_nombre_236)",
    id: "polygon1120"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-19",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "260.11 96.91 274.77 83.8 273.44 71.03 260.11 96.91",
    fill: "url(#Degradado_sin_nombre_237)",
    id: "polygon1122"
  }))), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.11 96.91 274.77 83.8 273.44 71.03 260.11 96.91",
    fill: "url(#Degradado_sin_nombre_238)",
    id: "polygon1125"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-20",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "264.22 77.69 273.44 71.03 247.34 67.81 264.22 77.69",
    fill: "url(#Degradado_sin_nombre_239)",
    id: "polygon1127"
  }))), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.22 77.69 273.44 71.03 247.34 67.81 264.22 77.69",
    fill: "url(#Degradado_sin_nombre_240)",
    id: "polygon1130"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.86 41.38 332.74 59.37 352.17 57.48 337.51 70.48 345.4 88.47 328.52 78.58 313.86 91.58 317.97 72.36 301.09 62.48 320.63 60.59 324.86 41.38",
    fill: "#4d8c42",
    id: "polygon1132"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-21",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.63 60.59 324.86 41.38 327.19 65.7 320.63 60.59",
    fill: "url(#Degradado_sin_nombre_241)",
    id: "polygon1134"
  }))), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.63 60.59 324.86 41.38 327.19 65.7 320.63 60.59",
    fill: "url(#Degradado_sin_nombre_242)",
    id: "polygon1137"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-22",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.17 57.48 332.74 59.37 327.19 65.7 352.17 57.48",
    fill: "url(#Degradado_sin_nombre_243)",
    id: "polygon1139"
  }))), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.17 57.48 332.74 59.37 327.19 65.7 352.17 57.48",
    fill: "url(#Degradado_sin_nombre_244)",
    id: "polygon1142"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-23",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.51 70.48 345.4 88.47 327.19 65.7 337.51 70.48",
    fill: "url(#Degradado_sin_nombre_245)",
    id: "polygon1144"
  }))), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.51 70.48 345.4 88.47 327.19 65.7 337.51 70.48",
    fill: "url(#Degradado_sin_nombre_246)",
    id: "polygon1147"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-24",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "313.86 91.58 328.52 78.58 327.19 65.7 313.86 91.58",
    fill: "url(#Degradado_sin_nombre_247)",
    id: "polygon1149"
  }))), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "313.86 91.58 328.52 78.58 327.19 65.7 313.86 91.58",
    fill: "url(#Degradado_sin_nombre_248)",
    id: "polygon1152"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID-25",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.97 72.36 327.19 65.7 301.09 62.48 317.97 72.36",
    fill: "url(#Degradado_sin_nombre_249)",
    id: "polygon1154"
  }))), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.97 72.36 327.19 65.7 301.09 62.48 317.97 72.36",
    fill: "url(#Degradado_sin_nombre_250)",
    id: "polygon1157"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1346",
    transform: "translate(-47.163402)"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: "44.43px",
    fill: "#4d8b3f",
    fontFamily: "Roboto-BoldCondensed, Roboto",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    },
    id: "text1163",
    x: 429.28,
    y: 66.800003
  }, "Campa\xF1a de recogida", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 654.90002,
    y: 66.800003,
    letterSpacing: "-0.01em",
    id: "tspan1159"
  }))), /*#__PURE__*/React.createElement("text", {
    fontSize: "44.43px",
    fill: "#4d8b3f",
    fontFamily: "Roboto-BoldCondensed, Roboto",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    },
    id: "text1169",
    x: 429.28,
    y: 109.4
  }, "de muebles, enseres", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 745.14001,
    y: 109.4,
    xmlSpace: "preserve",
    id: "tspan1167"
  }))), /*#__PURE__*/React.createElement("text", {
    fontSize: "44.43px",
    fill: "#4d8b3f",
    fontFamily: "Roboto-BoldCondensed, Roboto",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    },
    id: "text1175",
    x: 429.28,
    y: 152.10001
  }, "electrodom\xE9sticos"), /*#__PURE__*/React.createElement("text", {
    fontSize: "44.43px",
    fill: "#4d8b3f",
    fontFamily: "Roboto-BoldCondensed, Roboto",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    },
    id: "text1177",
    x: 429.28,
    y: 194.7
  }, "y podas")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.43,
    cy: 454.41,
    r: 11.98,
    transform: "translate(168.6 1113.04) rotate(-79.08)",
    fill: "#87b43d",
    id: "circle1181"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M762.6,443.16l-8.34,22.42a12,12,0,1,0,8.34-22.42Z",
    fill: "#87b43d",
    id: "path1183"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M747.19,450.23a12,12,0,0,0,7,15.4l8.34-22.42A11.94,11.94,0,0,0,747.19,450.23Z",
    fill: "#4e9142",
    id: "path1185"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 755.33,
    y: 459.78,
    width: 9,
    height: 1.1,
    transform: "translate(-128.39 442.39) rotate(-30.05)",
    fill: "#764d25",
    id: "rect1187"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 753.88,
    y: 450.04,
    width: 1.1,
    height: 8.34,
    transform: "translate(-126.05 438.87) rotate(-30.05)",
    fill: "#603a19",
    id: "rect1189"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 742.07,
    y: 461.69,
    width: 26.4,
    height: 2.1,
    transform: "translate(57.86 1008.8) rotate(-69.56)",
    fill: "#764d25",
    id: "rect1191"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 741.57,
    y: 462.08,
    width: 26.4,
    height: 0.99,
    transform: "translate(57.69 1008.22) rotate(-69.56)",
    fill: "#603a19",
    id: "rect1193"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.29,
    cy: 450.07,
    r: 15.46,
    fill: "#87b43d",
    id: "circle1195"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M781.26,434.55v31a15.49,15.49,0,0,0,0-31Z",
    fill: "#87b43d",
    id: "path1197"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M765.75,450.06a15.43,15.43,0,0,0,15.46,15.46v-31A15.51,15.51,0,0,0,765.75,450.06Z",
    fill: "#4e9142",
    id: "path1199"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 779.8,
    y: 455.89,
    width: 11.65,
    height: 1.38,
    transform: "translate(-66.41 772.34) rotate(-50.5)",
    fill: "#764d25",
    id: "rect1201"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 775.63,
    y: 446.26,
    width: 1.38,
    height: 10.82,
    transform: "translate(-66.01 763.37) rotate(-50.5)",
    fill: "#603a19",
    id: "rect1203"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 779.88,
    y: 444.54,
    width: 2.71,
    height: 34.13,
    fill: "#764d25",
    id: "rect1205"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 779.88,
    y: 444.54,
    width: 1.27,
    height: 34.13,
    fill: "#603a19",
    id: "rect1207"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.59,
    cy: 459.86,
    r: 10.66,
    transform: "translate(-67.09 775.15) rotate(-49.79)",
    fill: "#87b43d",
    id: "circle1209"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M805.28,449.84l-7.45,20a10.67,10.67,0,0,0,7.45-20Z",
    fill: "#87b43d",
    id: "path1211"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M791.59,456.14a10.65,10.65,0,0,0,6.29,13.69l7.46-20A10.69,10.69,0,0,0,791.59,456.14Z",
    fill: "#4e9142",
    id: "path1213"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 798.79,
    y: 464.61,
    width: 8.01,
    height: 0.99,
    transform: "translate(-125 464.47) rotate(-30.05)",
    fill: "#764d25",
    id: "rect1215"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 797.58,
    y: 456.01,
    width: 0.99,
    height: 7.45,
    transform: "translate(-122.94 461.47) rotate(-30.05)",
    fill: "#603a19",
    id: "rect1217"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 787,
    y: 466.38,
    width: 23.52,
    height: 1.88,
    transform: "matrix(0.35, -0.94, 0.94, 0.35, 81.87, 1052.54)",
    fill: "#764d25",
    id: "rect1219"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 786.55,
    y: 466.73,
    width: 23.52,
    height: 0.88,
    transform: "translate(81.72 1052.02) rotate(-69.56)",
    fill: "#603a19",
    id: "rect1221"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "g1255"
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.56,564.4c.1,9.8-70.3,18.3-157.2,18.9s-157.4-6.7-157.5-16.5,70.3-18.3,157.2-18.9S1128.46,554.6,1128.56,564.4Z",
    fill: "#060606",
    fillOpacity: 0,
    id: "path1223"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1125,564.4c.1,9.5-68.7,17.7-153.5,18.3s-153.7-6.5-153.8-16,68.7-17.7,153.5-18.3S1124.86,554.9,1125,564.4Z",
    fill: "#060606",
    opacity: 0.01,
    style: {
      isolation: "isolate"
    },
    id: "path1225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.36,564.3c.1,9.1-67,17.1-149.9,17.7s-150.1-6.3-150.1-15.4,67-17.1,149.9-17.7S1121.26,555.2,1121.36,564.3Z",
    fill: "#060606",
    opacity: 0.03,
    style: {
      isolation: "isolate"
    },
    id: "path1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.66,564.3c.1,8.8-65.4,16.5-146.2,17.1s-146.4-6.1-146.5-14.9,65.4-16.5,146.2-17.1S1117.66,555.5,1117.66,564.3Z",
    fill: "#060606",
    opacity: 0.04,
    style: {
      isolation: "isolate"
    },
    id: "path1229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.06,564.3c.1,8.5-63.8,15.9-142.6,16.5s-142.7-5.8-142.8-14.3,63.8-15.9,142.6-16.5S1114,555.8,1114.06,564.3Z",
    fill: "#060606",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    },
    id: "path1231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.46,564.3c.1,8.2-62.1,15.3-138.9,15.8s-139.1-5.6-139.1-13.8,62.1-15.3,138.9-15.8S1110.36,556.1,1110.46,564.3Z",
    fill: "#060606",
    opacity: 0.07,
    style: {
      isolation: "isolate"
    },
    id: "path1233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.86,564.3c.1,7.9-60.5,14.7-135.3,15.2s-135.4-5.4-135.5-13.2,60.5-14.7,135.3-15.2S1106.76,556.4,1106.86,564.3Z",
    fill: "#060606",
    opacity: 0.09,
    style: {
      isolation: "isolate"
    },
    id: "path1235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.26,564.3c.1,7.5-58.9,14.1-131.6,14.6s-131.8-5.1-131.8-12.7,58.9-14.1,131.6-14.6S1103.16,556.7,1103.26,564.3Z",
    fill: "#060606",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    },
    id: "path1237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.56,564.3c.1,7.2-57.2,13.5-127.9,14s-128.1-4.9-128.2-12.1,57.2-13.5,127.9-14S1099.56,557.1,1099.56,564.3Z",
    fill: "#060606",
    opacity: 0.11,
    style: {
      isolation: "isolate"
    },
    id: "path1239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096,564.2c.1,6.9-55.6,12.9-124.3,13.4s-124.4-4.7-124.5-11.6,55.6-12.9,124.3-13.4S1096,557.4,1096,564.2Z",
    fill: "#060606",
    opacity: 0.13,
    style: {
      isolation: "isolate"
    },
    id: "path1241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.36,564.2c.1,6.6-54,12.3-120.6,12.8S851,572.6,851,566s54-12.3,120.6-12.8S1092.26,557.7,1092.36,564.2Z",
    fill: "#060606",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    },
    id: "path1243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.76,564.2c.1,6.2-52.3,11.7-117,12.1s-117.1-4.2-117.2-10.5,52.3-11.7,117-12.1S1088.66,558,1088.76,564.2Z",
    fill: "#060606",
    opacity: 0.16,
    style: {
      isolation: "isolate"
    },
    id: "path1245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.06,564.2c0,5.9-50.7,11.1-113.3,11.5s-113.5-4-113.5-9.9,50.7-11.1,113.3-11.5S1085.06,558.3,1085.06,564.2Z",
    fill: "#060606",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    },
    id: "path1247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.46,564.2c0,5.6-49.1,10.5-109.7,10.9S862,571.3,862,565.7s49.1-10.5,109.7-10.9S1081.46,558.6,1081.46,564.2Z",
    fill: "#060606",
    opacity: 0.19,
    style: {
      isolation: "isolate"
    },
    id: "path1249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.86,564.2c0,5.3-47.4,9.9-106,10.3s-106.1-3.5-106.2-8.8,47.4-9.9,106-10.3S1077.86,558.9,1077.86,564.2Z",
    fill: "#060606",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    },
    id: "path1251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.26,564.2c0,5-45.8,9.3-102.4,9.7s-102.5-3.3-102.5-8.2,45.8-9.3,102.4-9.7S1074.16,559.2,1074.26,564.2Z",
    fill: "#060606",
    opacity: 0.21,
    style: {
      isolation: "isolate"
    },
    id: "path1253"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "706.79 163.88 735.14 221.31 798.52 230.6 752.72 275.29 763.49 338.42 706.79 308.59 650.09 338.42 660.99 275.29 615.06 230.6 678.44 221.31 706.79 163.88",
    fill: "#4e8c41",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.08,
    id: "polygon1257"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M763.49,338.79h-.13l-56.57-29.71-56.57,29.71c-.13.13-.25,0-.37,0a.43.43,0,0,1-.13-.37l10.77-63-45.68-44.56a.47.47,0,0,1-.12-.37.26.26,0,0,1,.25-.25l63.25-9.16,28.23-57.32a.35.35,0,0,1,.62,0l28.22,57.32,63.26,9.16a.27.27,0,0,1,.25.25.45.45,0,0,1-.13.37L753,275.41l10.77,63a.45.45,0,0,1-.12.37Zm-56.7-30.57h.12L763,337.68l-10.64-62.39c0-.13,0-.25.12-.25l45.31-44.19-62.64-9.16a.27.27,0,0,1-.25-.25l-28-56.82-28,56.82c0,.12-.13.12-.25.25l-62.89,9.16L661.11,275a.39.39,0,0,1,.12.25l-10.64,62.39,56.08-29.46C706.67,308.34,706.79,308.22,706.79,308.22Z",
    fill: "#404040",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.08,
    id: "path1259"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M666.19,306.36l.49-3a1.22,1.22,0,0,0-1-1.36h0a1.22,1.22,0,0,0-1.36,1L663,311.44h7.18l1.11-6.57a1.07,1.07,0,0,0-.74-1.36h0a1.22,1.22,0,0,0-1.36,1l-.5,2.48.62-3.71a1.24,1.24,0,0,0-1-1.37h0a1.23,1.23,0,0,0-1.36,1l-.74,3.47",
    fill: "#fff",
    id: "path1261"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M670.15,311.68H663c-.13,0-.13,0-.25-.12s-.12-.12-.12-.25l1.36-8.42a1.7,1.7,0,0,1,.62-1,1.25,1.25,0,0,1,1.11-.24,2,2,0,0,1,.87.49,1.5,1.5,0,0,1,1.61-.87A1.52,1.52,0,0,1,669.4,303v.12a1.31,1.31,0,0,1,1-.12c.38.12.75.25.87.62a1.62,1.62,0,0,1,.13,1.11l-1.12,6.56C670.39,311.56,670.27,311.68,670.15,311.68Zm-6.81-.62h6.56l1-6.31c.12-.49,0-1-.5-1a1.62,1.62,0,0,0-.74.12.69.69,0,0,0-.37.62l-.49,2.48c0,.12-.25.25-.38.25s-.24-.25-.24-.37l.62-3.72a.95.95,0,0,0-1.86-.37l-.13.74h0l-.49,3c0,.13-.25.25-.37.25s-.25-.25-.25-.37l.5-3c0-.25,0-.5-.13-.62a.67.67,0,0,0-.62-.37,1.62,1.62,0,0,0-.74.12.68.68,0,0,0-.37.62Z",
    fill: "#404040",
    id: "path1263"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M717.19,316H706.54s-.37,29-17.45,48.28l5.69,14.85S722.76,356.87,717.19,316Z",
    fill: "#e6e6e6",
    id: "path1265"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M694.78,379.52h0a.27.27,0,0,1-.25-.25l-5.69-14.85v-.37c16.71-19.07,17.33-47.79,17.33-48a.26.26,0,0,1,.25-.25h10.64a.26.26,0,0,1,.25.25,72.9,72.9,0,0,1-9.16,47c-6.31,10.64-13.24,16.34-13.37,16.34C694.91,379.52,694.78,379.52,694.78,379.52Zm-5.32-15.22,5.45,14.36a64.87,64.87,0,0,0,12.87-16,72,72,0,0,0,9.16-46.43H706.79C706.67,319.48,705.18,346.22,689.46,364.3Z",
    fill: "#404040",
    id: "path1267"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M669,348.57c-4.95,3.35-10.89,5.2-16.09,8.17s-10.15,7.43-11.26,13.37a16.65,16.65,0,0,0,2.59,11.27,29.53,29.53,0,0,0,8.42,8.17A37,37,0,0,0,668,395.74a22.41,22.41,0,0,0,15.85-4c7.18-5.45,9.28-15.23,11-24.14,1.23-6.69,2.47-13.37,3.59-19.93.86-4.46,1.36-9.78-1.86-12.88-3.47-3.34-9.29-5.94-13.12-3.22-2.11,1.61-5.33,7.56-6.94,9.54A28.82,28.82,0,0,1,669,348.57Z",
    fill: "#404040",
    id: "path1269"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M714.22,372.22c-.5-1.49-7.31-16.22-11-15.23-1-.25-11,1.73-11,1.73a8.83,8.83,0,0,0-2.23.62c-6.56-8.91-16.71-25.87-17.45-48.28H661.85s-7.18,37.76,21.79,63.51C686,391.28,689,409.36,689,409.36l.62,2.22h20.68c2-5.69,3.09-17.82,3.71-25.5C720.9,380.39,714.22,372.22,714.22,372.22Z",
    fill: "#e6e6e6",
    id: "path1271"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M710.26,412H689.58a.27.27,0,0,1-.24-.25l-.62-2.23c0-.25-3-18.2-5.33-34.66-15-13.37-20-30-21.78-41.6a73.08,73.08,0,0,1,0-22.16.26.26,0,0,1,.24-.24H672.5a.27.27,0,0,1,.25.24c.74,22.53,11,39.62,17.2,47.91a6.52,6.52,0,0,1,2.11-.49c1-.25,9.78-1.86,11-1.74,4.08-.86,10.77,14,11.26,15.35.5.62,6.31,8.67-.25,14.24-.49,7.06-1.73,19.68-3.71,25.5C710.5,411.83,710.38,412,710.26,412Zm-20.43-.62h20.3c2-5.82,3.1-18.32,3.59-25.26,0-.12,0-.12.13-.24a7.66,7.66,0,0,0,2.6-8.79,14.27,14.27,0,0,0-2.36-4.71v-.12c-.62-2.11-7.3-15.85-10.64-15h-.13c-.62-.12-6.93,1-10.89,1.73h0a8.15,8.15,0,0,0-2.1.62.48.48,0,0,1-.38-.12c-6.19-8.3-16.58-25.5-17.45-48.16H662.35a73.29,73.29,0,0,0,.12,21.79,67.27,67.27,0,0,0,21.67,41.22l.12.13c2.35,16.46,5.32,34.53,5.32,34.78Z",
    fill: "#404040",
    id: "path1273"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M745.66,545.16l-4.95-3-.25-10.27-8.91,1.24,3.84,11.63S740.71,547.88,745.66,545.16Z",
    fill: "#fff",
    id: "path1275"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M741.2,546.64a14.71,14.71,0,0,1-5.94-1.48c-.12,0-.12-.13-.12-.13L731.3,533.4v-.25c0-.13.12-.13.25-.13l8.91-1.23c.13,0,.13,0,.25.12s.12.12.12.25l.25,10,4.83,2.85c.12,0,.12.13.12.25a.46.46,0,0,1-.12.25A11.38,11.38,0,0,1,741.2,546.64Zm-5.57-2c.75.37,5.2,2.48,9.41.5l-4.45-2.73c-.13,0-.13-.12-.13-.25l-.25-9.9L732,533.4Z",
    fill: "#404040",
    id: "path1277"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M745.17,544.54c-3.35,2.72-10.16-.87-10.16-.87l-.86,7.06,18.69-3.22Z",
    fill: "#404040",
    id: "path1279"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M624.59,523.37l2.73-5.08,10.39-.62-2.1-8.79-11.14,4.21C624.47,513,621.74,518.54,624.59,523.37Z",
    fill: "#fff",
    id: "path1281"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M624.59,523.62c-.12,0-.25,0-.25-.13-3-5-.24-10.4-.12-10.64a.12.12,0,0,1,.12-.13l11.15-4.21h.24c.13,0,.13.13.13.25l2.1,8.79v.25c0,.12-.12.12-.25.12l-10.27.62-2.72,5c.12.13,0,.13-.13.13Zm.13-10.4c-.38.74-2.36,5.32-.13,9.41l2.48-4.58c0-.13.12-.13.25-.13l10-.62-1.85-8Z",
    fill: "#404040",
    id: "path1283"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M625.21,522.75c-2.85-3.22.5-10.15.5-10.15l-7.18-.5,4,18.45Z",
    fill: "#404040",
    id: "path1285"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M686.86,342.88l-.5-5.7,6.19-4.45,11.15,4.95,1.73,8.42a7.14,7.14,0,0,1-2.35,7h0l1.11,5.82h0c-1,3.72-4.83,4.95-8.67,4.46-3.34-.5-4-4.46-4-4.46l-3.22-9.9s-4.58,2.1-5.32-2.23,3.84-4,3.84-4",
    fill: "#fff",
    id: "path1287"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M697.13,363.8a9,9,0,0,1-1.73-.12c-3.34-.5-4.21-4.34-4.33-4.71l-3.1-9.53a5.26,5.26,0,0,1-3.71.12,3.63,3.63,0,0,1-1.73-2.72,3.48,3.48,0,0,1,.74-3.22,4.61,4.61,0,0,1,3.22-1.11l-.5-5.33c0-.12,0-.24.13-.24l6.19-4.46c.12-.12.24-.12.24,0l11.14,4.95c.13,0,.13.13.13.25l1.73,8.42a7.12,7.12,0,0,1-2.35,7.18l1.11,5.69v.13C703.7,362.07,700.85,363.8,697.13,363.8Zm-8.91-15.1h0c.25,0,.25.12.25.24l3.22,9.91h0s.74,3.84,3.71,4.21c5.08.74,7.55-1.61,8.29-4.09l-1.11-5.82a.47.47,0,0,1,.12-.37h0a7.05,7.05,0,0,0,2.23-6.68l-1.73-8.3L692.31,333l-5.95,4.2.5,5.58c0,.12,0,.12-.12.24s-.13.13-.25.13a4.19,4.19,0,0,0-3.1.86,3,3,0,0,0-.49,2.6,2.93,2.93,0,0,0,1.36,2.23c1.48.74,3.47-.25,3.47-.25Z",
    fill: "#404040",
    id: "path1289"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M693.67,341.15h-.13a.25.25,0,0,1,0-.38,2.16,2.16,0,0,1,3-.61.45.45,0,0,1,.12.37.46.46,0,0,1-.37.12,1.59,1.59,0,0,0-2.23.5Z",
    fill: "#404040",
    id: "path1291"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M700.6,339.29c-.12,0-.12,0-.25-.12a.25.25,0,0,1,0-.38,1.8,1.8,0,0,1,2.48-.37.47.47,0,0,1,.12.37.44.44,0,0,1-.37.13,1.25,1.25,0,0,0-1.73.25A.41.41,0,0,1,700.6,339.29Z",
    fill: "#404040",
    id: "path1293"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M698.5,355.26a.27.27,0,0,1-.25-.25c0-.12.12-.37.25-.37l1.61-.37a6.24,6.24,0,0,0,2.84-1.49c.13-.12.37-.12.37,0s.13.37,0,.37a9,9,0,0,1-3.09,1.61l-1.73.5Z",
    fill: "#404040",
    id: "path1295"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M684.88,348.08c-.13,0-.25,0-.25-.13a2.76,2.76,0,0,1-.37-2.35c.37-1,1.36-1.36,1.36-1.48a.28.28,0,1,1,.25.49,2.16,2.16,0,0,0-1,1.12,2.72,2.72,0,0,0,.37,1.85.24.24,0,0,1-.12.37A.39.39,0,0,1,684.88,348.08Z",
    fill: "#404040",
    id: "path1297"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M686.86,347.34c-.12,0-.12,0-.25-.13a4.63,4.63,0,0,0-2.1-1.11c-.13,0-.25-.13-.25-.37s.12-.25.37-.25a5,5,0,0,1,2.35,1.24c.13.12.13.37,0,.37C687,347.34,687,347.34,686.86,347.34Z",
    fill: "#404040",
    id: "path1299"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M696.27,341.89c.12.37.12.87-.13.87s-.62-.13-.74-.62-.12-.87.12-.87A.93.93,0,0,1,696.27,341.89Z",
    fill: "#404040",
    id: "path1301"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M702.46,339.91c.12.37.12.86-.13.86s-.62-.12-.74-.61-.12-.87.12-.87A.93.93,0,0,1,702.46,339.91Z",
    fill: "#404040",
    id: "path1303"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M702.7,333.1a7.14,7.14,0,0,0-5.81-5.45,15,15,0,0,0-7.55.62c-6.57,2.85-9,5.82-7.8,10.28,0,.12,1.73,6.19,1.73,6.19,1-1.74,3.59-1.37,3.59-1.37,4.7-4.08,4.7-8,4.7-8s6.69,4.21,12.51,2.84Z",
    fill: "#404040",
    id: "path1305"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M706.05,463.33,700.48,494A15.3,15.3,0,0,1,689,506L637.84,522.5l-3.72-18.07,45.06-17L686,442.78Z",
    fill: "#77b383",
    id: "path1307"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M637.84,522.87h-.13c-.12,0-.12-.12-.12-.24l-3.71-18.08a.35.35,0,0,1,.24-.37l44.94-17,6.81-44.44a.27.27,0,0,1,.25-.25.45.45,0,0,1,.37.13l20.18,20.55c.12.12.12.12.12.24l-5.57,30.7a15.36,15.36,0,0,1-11.76,12.26l-51.62,16.46Zm-3.47-18.19L638,522.13l50.76-16.34A15,15,0,0,0,700.11,494l5.57-30.58-19.56-19.93-6.69,44.07a.26.26,0,0,1-.25.25Z",
    fill: "#404040",
    id: "path1309"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M689.71,411.46a81.88,81.88,0,0,0-6,16.71,21.06,21.06,0,0,0,6.07,19.56l28.84,26.74,5.2,59.92,20.18-2.85-2.72-54.84a43.14,43.14,0,0,0-5.57-21.05l-25.38-44.31Z",
    fill: "#77b383",
    id: "path1311"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M723.75,534.51c-.12,0-.12,0-.25-.12s-.12-.13-.12-.25l-5.2-59.79-28.72-26.74a21.58,21.58,0,0,1-6.19-19.81,71.21,71.21,0,0,1,6.07-16.71c0-.13.12-.13.24-.13l20.43-.24h0c.12,0,.25,0,.25.12l25.37,44.32a42.34,42.34,0,0,1,5.7,21.17l2.72,54.84c0,.12-.12.24-.25.37l-20,3Zm-33.92-122.8A75,75,0,0,0,684,428.17,20.61,20.61,0,0,0,690,447.36L718.8,474.1a.42.42,0,0,1,.12.25l5.2,59.54,19.56-2.72L741,476.57a42.68,42.68,0,0,0-5.57-20.92L710,411.46Z",
    fill: "#404040",
    id: "path1313"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M708,316l-1.24-6.32a1.34,1.34,0,0,1,.87-1.48h0a1.33,1.33,0,0,1,1.48.86l.74,1.12,5.82,3.34-.37,2.48Z",
    fill: "#fff",
    id: "path1315"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M715.46,316.26h-7.31a.27.27,0,0,1-.25-.24l-1.23-6.32a1.6,1.6,0,0,1,1.11-1.85,1.54,1.54,0,0,1,1.86,1l.62,1,5.81,3.34c.13.12.13.12.13.25l-.37,2.47C715.7,316.14,715.58,316.26,715.46,316.26Zm-7.18-.62h6.8l.25-2-5.69-3.21a.13.13,0,0,1-.13-.13l-.74-1.11v-.13a.9.9,0,1,0-1.73.5Z",
    fill: "#404040",
    id: "path1317"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M713.35,315a.28.28,0,0,1-.25-.25c-.12-1-2-2-2.72-2.35-.12,0-.12-.13-.12-.25l-.62-1.86c0-.12,0-.37.24-.37s.38,0,.38.25l.49,1.73c.62.25,2.85,1.36,3,2.72a.33.33,0,0,1-.37.38Z",
    fill: "#404040",
    id: "path1319"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M701,347.71h-.12a.45.45,0,0,1-.13-.37,2,2,0,0,0,.5-.87.59.59,0,0,0-.12-.74.39.39,0,0,0-.25-.13h-.25c-.12.13-.12.13-.25,0s-.12-.12-.24-.25a15.68,15.68,0,0,1-.87-4.08c0-.12.12-.37.25-.37s.37.12.37.25a16.82,16.82,0,0,0,.74,3.59h.25a1.05,1.05,0,0,1,.74.37,1.72,1.72,0,0,1,.25,1.36,2.78,2.78,0,0,1-.62,1C701.22,347.71,701.1,347.71,701,347.71Z",
    fill: "#404040",
    id: "path1321"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M697.26,348.82s4.21,1.61,7-1c0,0-1,3.59-3.21,4C698.74,351.92,697.26,348.82,697.26,348.82Z",
    fill: "#404040",
    id: "path1323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNuevo);
export default __webpack_public_path__ + "static/media/header_nuevo.fcb8de4d.svg";
export { ForwardRef as ReactComponent };